import React from "react";
import { Box } from "@mui/material";

interface DotsIndicatorProps {
  total?: number;
  activeIndex: number;
}

export const DotsIndicator: React.FC<DotsIndicatorProps> = ({
  total = 8,
  activeIndex,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {Array.from({ length: total }).map((_, index) => {
        const isActive = index === activeIndex;
        return (
          <Box
            key={index}
            sx={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: isActive ? "#06B6D4" : "#E2E5F5",
              transition: "all 0.3s ease",
              transform: isActive ? "scale(1.2)" : "scale(1)",
            }}
          />
        );
      })}
    </Box>
  );
};
